var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{ref:"videoPlayer",staticClass:"video-js vjs-theme-fantasy",style:({
      width: _vm.options.width || '100%',
      height: _vm.options.height || '100%',
    })})])
}
var staticRenderFns = []

export { render, staticRenderFns }